<template>
  <div id="checkout">
    <menu-default/>
    <main class="page payment-page">
      <section class="int-form">
        <div class="container">
          <div class="block-heading">
            <h2><i class="fa fa-credit-card"></i> Dados do Pedido</h2>
            <p v-show="!logged">Já possui um cadastro? <a class="btn btn-link" herf="#" @click="redirectURL({name: 'login'})">Faça seu login</a></p>
          </div>
          <form style="max-width:800px">
            <div class="products">
              <h3 class="title">Produtos</h3>
              <div v-for="(item, index) in refactored_cart" class="item" v-bind:key="index">
                <span class="price">R$ {{item.price | formatPrice}}</span>
                <p class="item-name">{{refactored_cart[index].quantity}}x {{item.name}} {{item.weight}}</p>
                <div v-for="(info, key) in refactored_cart[index].items" v-bind:key="key">

                  <div v-show="refactored_cart[index].has_airplane_info" class="item-description" style="background: #f5f6f9; padding: 10px; border-top: #d8d8d8 1px solid;">
                    <div class="row">
                      <div class="form-group col-sm-4">
                        <label>Prefixo da aeronave</label>
                        <input :id="'airplane_prefix_' + index + '_' + key" v-mask="'AA-AAA'" type="text" v-model="refactored_cart[index].items[key].airplane_prefix" class="form-control">
                        <span class="errorForm"></span>
                      </div>
                      <div class="form-group col-sm-4">
                        <label>Numero de Série</label>
                        <input :id="'airplane_serial_number_' + index + '_' + key" type="text" v-model="refactored_cart[index].items[key].airplane_serial_number" class="form-control">
                        <span class="errorForm"></span>
                      </div>
                      <div class="form-group col-sm-4">
                        <label>Tipo de Combustível</label>
                        <select :id="'fuel_type_' + index + '_' + key" class="form-control" v-model="refactored_cart[index].items[key].fuel_type">
                          <option :value="0">Não Informado</option>
                          <option :value="1">Gasolina</option>
                          <option :value="2">Etanol</option>
                          <option :value="3">Convertido para Etanol</option>
                        </select>
                        <span class="errorForm"></span>
                      </div>
                    </div>
                  </div>

                  <div v-show="refactored_cart[index].has_photo_upload" class="item-description" style="background: #f5f6f9; padding: 10px;">
                    <div class="row">
                      <div class="form-group col-sm-8" style="font-size: 12px;">
                        Para a aquisição deste documento é necessário o envio de uma fotografia da primeira página do manual (cor laranja)
                      </div>
                      <div class="form-group col-sm-4">
                        <div style="margin-bottom: 20px;" v-show="uploadPercentage > 0" class="progress">
                          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>

                        <file-select v-model="file" :cartItem="index" :itemNumber="key"></file-select>
                        <img v-show="refactored_cart[index].items[key].file_path" v-bind:src="refactored_cart[index].items[key].file_path" width="34" height="34" />

                        <span :id="'file_' + index + '_' + key"></span>
                        <span class="errorForm" style="display: block;"></span>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-details">
              <h3 class="title">Detalhes do pedido</h3>
              <div class="row">
                <div class="form-group col-sm-6">
                  <label for="name">Nome</label>
                  <input :disabled="logged" id="name" type="text" v-model="checkout.profile.name" class="form-control" >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="user_email">E-mail</label>
                  <input id="user_email" type="text" v-model="checkout.profile.email" class="form-control" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="cpf">CPF</label>
                  <input :disabled="logged" id="cpf" type="text" v-mask="'###.###.###-##'" class="form-control" v-model="checkout.profile.cpf" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="phone">Telefone</label>
                  <input id="phone"  v-mask="['(##) ####-####', '(##) #####-####']" type="text" v-model="checkout.profile.phone" class="form-control" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="ie">Inscrição Estadual</label>
                  <input :required="checkout.profile.person_or_company" id="ie" type="text" class="form-control" maxlength="12" v-model="checkout.profile.ie" :placeholder="checkout.profile.person_or_company"  >
                  <span class="errorForm"></span>
                </div>
              </div>

              <hr />
              <div class="row">
                <div class="col-sm-12">
                  <label for="person_or_company"><input :disabled="!user.person_or_company" type="checkbox" id="person_or_company" v-model="checkout.profile.person_or_company"> Emitir nota fiscal como pessoa Jurídica</label>
                </div>
                <div class="row col-sm-12">
                  <div class="form-group col-sm-6">
                    <label for="company_name">Razão Social</label>
                    <input :disabled="logged" id="company_name" type="text" v-model="checkout.profile.company_name" class="form-control" :placeholder="checkout.profile.company_name" >
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="cnpj">CNPJ</label>
                    <input :disabled="logged" id="cnpj" v-mask="'##.###.###/####-##'" type="text" v-model="checkout.profile.cnpj" class="form-control" placeholder=""  >
                    <span class="errorForm"></span>
                  </div>
                </div>

              </div>
              <hr v-show="!logged"/>
              <div class="row" v-show="!logged">
                <div class="form-group col-sm-12">
                  <label for="user_password">Defina uma senha de acesso</label>
                  <input id="user_password" type="password" v-model="checkout.profile.password" class="form-control" >
                  <span class="errorForm"></span>
                </div>
              </div>
              <hr/>
              <div class="row">
                <div class="col-12">
                  <h3 class="subtitle">Endereço de Nota Fiscal</h3>
                </div>
                <div class="form-group col-sm-6">
                  <label for="billing_address_country">País</label>
                  <input id="billing_address_country" v-model="checkout.address.billing_address.country" type="text"  disabled="disabled" value="Brasil" class="form-control" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="billing_address_zip_code">CEP</label>
                  <input id="billing_address_zip_code" v-model="checkout.address.billing_address.zip_code" type="text" v-mask="'#####-###'" class="form-control" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="billing_address_street">Endereço</label>
                  <input id="billing_address_street" v-model="checkout.address.billing_address.street" type="text" class="form-control" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="billing_address_number">Número</label>
                  <input id="billing_address_number" v-model="checkout.address.billing_address.number" type="text" class="form-control" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="billing_address_complement">Complemento</label>
                  <input id="billing_address_complement" v-model="checkout.address.billing_address.complement" type="text" class="form-control" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="billing_address_province">Bairro</label>
                  <input id="billing_address_province" v-model="checkout.address.billing_address.province" type="text" class="form-control" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="billing_address_city">Cidade</label>
                  <input id="billing_address_city" v-model="checkout.address.billing_address.city" type="text" class="form-control"  placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="billing_address_state">UF</label>
                  <input id="billing_address_state" v-model="checkout.address.billing_address.state" v-mask="'AA'" type="text" class="form-control" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-12" v-show="!logged">
                  <input v-model="checkBoxAddress" id="checkBoxAddress" type="checkbox"> <label for="checkBoxAddress">usar outro endereço para entrega</label>
                </div>
              </div>
              <div class="row" id="shippingAddressBlock" v-show="logged">
                <div class="col-12">
                  <h3 class="subtitle">Endereço de Envio</h3>
                </div>
                <div class="form-group col-sm-6">
                  <label for="shipping_address_country">País</label>
                  <input id="shipping_address_country" v-model="checkout.address.shipping_address.country" type="text"  disabled="disabled" value="Brasil" class="form-control" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="shipping_address_zip_code">CEP</label>
                  <input id="shipping_address_zip_code" v-model="checkout.address.shipping_address.zip_code" type="text" v-mask="'#####-###'" class="form-control" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="shipping_address_street">Endereço</label>
                  <input id="shipping_address_street" v-model="checkout.address.shipping_address.street" type="text" class="form-control" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="shipping_address_number">Número</label>
                  <input id="shipping_address_number" v-model="checkout.address.shipping_address.number" type="text" class="form-control" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="shipping_address_complement">Complemento</label>
                  <input id="shipping_address_complement" v-model="checkout.address.shipping_address.complement" type="text" class="form-control" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="shipping_address_province">Bairro</label>
                  <input id="shipping_address_province" v-model="checkout.address.shipping_address.province" type="text" class="form-control" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="shipping_address_city">Cidade</label>
                  <input id="shipping_address_city" v-model="checkout.address.shipping_address.city" type="text" class="form-control" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
                <div class="form-group col-sm-6">
                  <label for="shipping_address_state">UF</label>
                  <input id="shipping_address_state" v-model="checkout.address.shipping_address.state" v-mask="'AA'" type="text" class="form-control" placeholder=""  >
                  <span class="errorForm"></span>
                </div>
              </div>
            </div>
            <hr  v-show="total_weight > 0" />
            <div v-show="total_weight > 0" class="card-details">
              <h3 v-show="cep_shipping" class="subtitle">Forma de envio</h3>

              <div class="row">
                <div v-show="cep_shipping" class="form-group col-sm-12">
                  <div v-if="services === null || (!loading_shipping && services.length === 0)">
                    Aguardando um CEP válido
                  </div>
                  <div v-else>
                    <div v-if="loading_shipping">
                      <i class="fa fa-refresh fa-spin" style="font-size:24px"></i> Carregando serviços e valores...
                    </div>
                    <div v-else>
                      <div class="form-check">
                        <input v-model="checkBoxToCombine" class="form-check-input" type="checkbox" value="" id="checkBoxToCombine">
                        <label class="form-check-label" for="defaultCheck1">
                          Envio à Combinar (Frete negociado após aprovação) [Beta]
                        </label>
                      </div> 
                      <div v-if="!checkBoxToCombine">                    
                        <select class="form-control" id="shipping_value" v-model="checkout.shipping_type" v-bind:disabled="checkBoxToCombine">
                          <option value="" >Selecione a forma de envio</option>
                            <option  v-for="service in services" v-bind:key="service.Valor"  v-bind:value="service.service">
                              {{service.service}} - R$ {{service.Valor}} - {{service.PrazoEntrega | sumNumber(5) }} dias
                            </option>
                        </select>
                        <span class="errorForm"></span>                      
                        <small class="shipping_advice">* Caso tenha interesse em outros tipos de envio, <a href="#" @click="redirectURL({name: 'contact'})">contate-nos</a> antes de fechar o pedido, ou escolha 'ENVIO À COMBINAR'</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="products" style="border-top: solid 1px #0000001a; ">
              <h3 class="title">Resumo do pedido</h3>

              <div class="total">Total de {{ total_quantity }} produtos<span class="price">R$ {{ products_total_value | formatPrice }}</span></div>
              <div v-show="shipping_value > 0.01" class="total">Total de <span v-show="checkout.shipping_type">{{checkout.shipping_type}} para {{actual_cep_shipping}}</span> <span class="price">R$ {{ shipping_value | formatPrice }}</span></div>
              <div v-if="!checkBoxToCombine" class="total">Total do pedido<span class="price">R$ {{ order_value | formatPrice }}</span></div>
              <div v-if="checkBoxToCombine" class="total">Total do pedido<span class="price">R$ {{ order_value - 0.01 | formatPrice }}</span></div>
            </div>

            <div class="card-details" style="padding-top: 0">
              <div class="row">
                <div class="form-group col-sm-12">
                  <div id="errorFound" class="alert alert-danger" role="alert" style="display: none;  margin-top: 30px;">Um erro foi encontrado. Verifique os campos do formulário</div>
                  <button type="button" class="btn btn-primary btn-block" @click="processCheckout()">Confirmar pedido e gerar Boleto</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    </main>
    <!-- Small modal -->
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="loginAdvice" id="loginAdvice" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" style="color: red">Você não está logado!</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>Caso ainda não tenha uma conta, continue o pedido para criar uma nova. Caso já tenha acesso, faça login antes de finalizar o pedido.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="redirectURL({name: 'login'})">Fazer login</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Criar nova conta</button>
      </div>
        </div>
      </div>
    </div>
    <footer-default/>
  </div>
</template>

<script>
  import menuDefault from "./common/menu-default"
  import footerDefault from "./common/footer-default"
  import { mapState } from 'vuex'
  import { mask } from 'vue-the-mask'
  import user from "../api/user"
  import mixins from "../helpers/mixins"
  import auth from '../api/auth'
  import FileSelect from './FileSelectCheckout.vue'
  import order from '../api/order'
  import axios from 'axios'
  import { CONFIGS } from '../configs'
  import _ from 'lodash';

  export default {
    name: "Checkout",
    mixins: [mixins],
    data() {
      return {
        file: null,
        uploadPercentage: 0,
        refactored_cart: [],
        publications: [],
        has_photo_upload: false,
        services: null,
        loading_shipping: false,
        shipping_price: null,
        checkBoxAddress: false,
        actual_cep_shipping: null,
        total_weight: 0,
        total_quantity: 0,
        checkBoxToCombine: false,
        user: this.$store.state.user
      }
    },
    created: function () {
      this.debouncedloadShippingPrices = _.debounce(this.loadShippingPrices, 500)
    },
    computed: {
      ...mapState({
        'logged': state => state.logged,
        'checkout': state => state.checkout,
        'cart': function(){ return this.$store.getters.getCart }
      }),
      cep_shipping: function () {
        let cep_to_ship = null

        if(this.checkout.address.shipping_address.zip_code === undefined)
          return cep_to_ship

        let bill_addr = this.checkout.address.billing_address.zip_code
        if(this.checkBoxAddress || this.logged) {
          if (this.checkout.address.shipping_address.zip_code !== undefined) {
            let ship_addr = this.checkout.address.shipping_address.zip_code
            if (ship_addr.length === 9) {
              cep_to_ship = ship_addr
            } else {
              if (ship_addr.length === 0) {
                if (bill_addr.length === 9)
                  cep_to_ship = bill_addr
              }
            }
          }
        } else {
          if(bill_addr.length === 9)
            cep_to_ship = bill_addr
        }

        // avoid unecessary call
        if(cep_to_ship != null && this.actual_cep_shipping !== cep_to_ship && this.total_weight !== 0){
          this.debouncedloadShippingPrices()
        }

        return cep_to_ship
      },
      products_total_value() {
        let products_total_value = 0.00
        this.refactored_cart.forEach(function(item) {
          products_total_value = Number(products_total_value) + (Number(item.quantity) * Number(item.price))
        });
        return products_total_value
      },
      shipping_value() {
        if(!this.checkBoxToCombine){
          for(let key in this.services) {
            if(this.services[key]['service'] === this.checkout.shipping_type){
              if(this.services[key]['Valor'] !== undefined)
                return parseFloat(this.services[key]['Valor'].replace(',', '.')).toFixed(2)
            }
          }
        }else{
          return 0.01
        }
        return 0.00
      },
      order_value(){
        return parseFloat(this.products_total_value) + parseFloat(this.shipping_value)
      }
    } ,
    components: { menuDefault, footerDefault, FileSelect },
    methods: {
      loadShippingPrices(){
        if(!this.loading_shipping){
          this.services = []
          this.loading_shipping = true
          let cep_to_ship = this.cep_shipping
          this.actual_cep_shipping = cep_to_ship
          let cep = cep_to_ship
          if(cep != null)
            cep = cep_to_ship.replace("-", "")
          let weight = Math.ceil(this.total_weight)
          order.get_shipping_price({
            'cep': cep,
            'peso': weight.toString(),
            'comprimento': 36,
            'largura': 26,
            'altura': 5,
            'diametro': 36
          }).then(response => {
            if(response.status === 200){
              let loaded_services = response.data 
              for(let key in loaded_services){
                if(!loaded_services[key]['MsgErro']){
                  this.services.push(loaded_services[key])
                } else {
                  //console.log(loaded_services[key])
                }
              }
            }
            this.loading_shipping = false
                      setTimeout(function(){
                        $("#shipping_value").val('')
                      }, 200);

          }).catch(errors => { this.formErrors(errors); this.loading_shipping = false; })

          // for fast debbug
          // let loaded_services = [{"service":"SEDEX","Valor":"18,90","PrazoEntrega":"1","MsgErro":null},{"service":"SEDEX 10","Valor":"0,00","PrazoEntrega":"0","MsgErro":"Para este serviço só está disponível o cálculo do PRAZO."},{"service":"PAC","Valor":"0","PrazoEntrega":"0","MsgErro":"ERP-007: CEP de origem nao pode postar para o CEP de destino informado."}]
          // for(let key in loaded_services){
          //   if(!loaded_services[key]['MsgErro']){
          //     this.services.push(loaded_services[key])
          //   }
          // } this.loading_shipping = false


        } else {
          let that = this
          setTimeout(function(){
            that.debouncedloadShippingPrices()
          }, 200);
        }


      },
      uploadFile(cartItemIndex, itemNumberKey){
        if(this.file){
          let formData = new FormData();
          formData.append("file", this.file);
          let that = this
          axios.post(CONFIGS.API_SERVER + '/api/order_upload_image/', formData, {
            headers: {'Content-Type': 'multipart/form-data'},
            onUploadProgress: function( progressEvent ) {
              this.uploadPercentage = parseInt(Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ));
              let percent = this.uploadPercentage+'%'
              $('.progress-bar').css({'width': percent}).html(percent)
              if(this.uploadPercentage === 100) $('.progress-bar').html('Arquivo enviado')
            }.bind(this)
          }).then(function (response) {
            if(response.status === 200){
              let cart_file = response.data

              that.$set(that.refactored_cart[cartItemIndex].items[itemNumberKey], 'file', cart_file)
              that.$set(that.refactored_cart[cartItemIndex].items[itemNumberKey], 'file_path', CONFIGS.API_SERVER + '/media/' + cart_file)

              $('.progress').fadeOut()
              $(".errorForm").html('')
            }
          })

        }
        return true
      },
      processCheckout(){
        this.updateOrCreateUser().then((return_data) => {
          this.createOrder(return_data)
        })
      },
      updateOrCreateUser(){

        return new Promise((resolve) => {
          let person_or_company = 0

          if(this.$store.state.checkout.profile.person_or_company) person_or_company = 1

          let update_data = {
            "user": { "email": this.$store.state.checkout.profile.email },
            "name": this.$store.state.checkout.profile.name,
            "person_or_company": person_or_company,
            "company_name": this.$store.state.checkout.profile.company_name,
            "phone": this.$store.state.checkout.profile.phone,
            "cnpj": this.$store.state.checkout.profile.cnpj,
            "cpf": this.$store.state.checkout.profile.cpf,
            "ie": this.$store.state.checkout.profile.ie,
            "billing_address": this.$store.state.checkout.address.billing_address,
            "shipping_address": null
          }

          if($("#checkBoxAddress").prop('checked') || this.logged){
            update_data.shipping_address = this.$store.state.checkout.address.shipping_address
          } else {
            update_data.shipping_address = this.$store.state.checkout.address.billing_address
          }

          if(this.$store.state.checkout.profile.id !== undefined){
            user.update(update_data, this.$store.state.checkout.profile.id).then((response) => {
              if(response.status === 200){
                this.$store.commit('setUser', response.data)
                resolve({
                  profile: this.$store.state.checkout.profile.id,
                  address: this.$store.state.checkout.address.shipping_address
                })
              } else {
                alert('ATENÇÃO: Não foi possivel atualizar seu usuário');
              }
            }).catch(errors => { this.formErrors(errors) })
          } else {
            update_data.user.password = $("#user_password").val()
            user.create(update_data).then((response) => {
              if(response.status === 201){
                auth.getToken({ username: update_data.user.email, password: update_data.user.password }).then((response_auth) => {
                  this.$store.commit('setToken', response_auth.data.access)
                  user.list(1, update_data.user.email).then((response_user_list) => {
                    let user_data = response_user_list.data.results[0]
                    this.$store.commit('setUser', user_data)

                    resolve({
                      profile: user_data.id,
                      address: this.$store.state.checkout.address.shipping_address
                    })
                  })
                })
              } else {
                alert('ATENÇÃO: Não foi possivel criar seu usuário');
              }
            }).catch(errors => { this.formErrors(errors) })
          }
        })
      },
      createOrder(data){
        if(this.refactorToSend()){
          data = {
            profile: data.profile,
            status:1 ,
            publications: this.publications,
            shipping_type: this.checkBoxToCombine?'À Combinar':this.checkout.shipping_type,
            shipping_value: this.shipping_value
          }

          let has_photo_upload = this.has_photo_upload
          order.create(data).then((return_data) => {
            if(return_data.status === 201) {
              const orderID = return_data.data.id
              this.$store.state.checkout.order = orderID
              this.$store.commit('updateCheckout', this.$store.state.checkout)
              if(has_photo_upload)
                this.$router.push({name: 'payment_return', params: { return_data: { status: 200 } }})
              else
                this.$router.push({name: 'payment', params: { order: orderID }})
            } else {
              alert('ATENÇÃO: Não foi possivel criar seu pedido');
            }
          }).catch(errors => { this.formErrors(errors) })
        }

      },
      refactorToSend(){

        let obj = {}
        this.publications = []
        this.has_photo_upload = false

        for (let key in this.refactored_cart){
          if(this.refactored_cart[key].items.length === 0){
            if(this.refactored_cart[key].has_photo_upload){
              if(this.refactored_cart[key].file === undefined || this.refactored_cart[key].file === '' || this.refactored_cart[key].file === null)
                obj['file_' + key] = ['Campo obrigatório']
              this.has_photo_upload = true
            }


            for (let i = 0; i < this.refactored_cart[key].quantity; i++){
              this.publications.push({
                publication: this.refactored_cart[key].id,
                value: this.refactored_cart[key].price,
                airplane_prefix: '',
                airplane_serial_number: '',
                fuel_type: 0,
                file: this.refactored_cart[key].file
              })
            }

          } else {
            for (let item_key in this.refactored_cart[key].items){
              if(this.refactored_cart[key].has_photo_upload){
                if(this.refactored_cart[key].items[item_key].file === undefined || this.refactored_cart[key].items[item_key].file === '' || this.refactored_cart[key].items[item_key].file === null)
                  obj['file_' + key + '_' + item_key] = ['Envio obrigatório']
                this.has_photo_upload = true
              }

              if(this.refactored_cart[key].items[item_key].airplane_prefix === undefined || this.refactored_cart[key].items[item_key].airplane_prefix === '')
                obj['airplane_prefix_' + key + '_' + item_key] = ['Campo obrigatório']

              if(this.refactored_cart[key].items[item_key].airplane_prefix.length !== 6)
                obj['airplane_prefix_' + key + '_' + item_key] = ['Prefixo incorreto']

              if(this.refactored_cart[key].items[item_key].airplane_serial_number === undefined || this.refactored_cart[key].items[item_key].airplane_serial_number === '')
                obj['airplane_serial_number_' + key + '_' + item_key] = ['Campo obrigatório']

              if(this.refactored_cart[key].items[item_key].fuel_type === undefined || this.refactored_cart[key].items[item_key].fuel_type === '' || this.refactored_cart[key].items[item_key].fuel_type === 0)
                obj['fuel_type_' + key + '_' + item_key] = ['Campo obrigatório']

              this.publications.push({
                publication: this.refactored_cart[key].id,
                value: this.refactored_cart[key].price,
                airplane_prefix: this.refactored_cart[key].items[item_key].airplane_prefix,
                airplane_serial_number: this.refactored_cart[key].items[item_key].airplane_serial_number,
                fuel_type: this.refactored_cart[key].items[item_key].fuel_type,
                file: this.refactored_cart[key].items[item_key].file
              })
            }
          }
        }

        if(Object.keys(obj).length > 0) {
          mixins.methods.formErrors(obj)
          // throw new Error("Validation form error!");
          return false
        } else {
          return true
        }

      },
      refactorCart(){
        this.refactored_cart = JSON.parse(JSON.stringify(this.cart));

        for (let key in this.refactored_cart) {
          let product_weight =  parseFloat(this.refactored_cart[key].weight) * parseInt(this.refactored_cart[key].quantity)
          this.total_weight = this.total_weight + product_weight
          this.total_quantity = this.total_quantity + parseInt(this.refactored_cart[key].quantity)

          this.$set(this.refactored_cart[key], 'items', [])
          if(this.refactored_cart[key].has_airplane_info){
            let i;
            for (i = 0; i < this.refactored_cart[key].quantity; i++) {
              this.refactored_cart[key].items.push({ airplane_prefix: '', airplane_serial_number: '', fuel_type: 0, file: '' })
            }
          }
        }
      }
    },
    mounted(){
      if(this.cart.length === 0){
        this.$router.push({name: 'cart'})
      } else {
        this.refactorCart()
      }

      $("#checkBoxAddress").change(function() {
        $("#shippingAddressBlock").slideToggle()
      })

      if(this.logged){
        this.checkBoxAddress = true
      } else {
        this.checkBoxAddress = false
        $("#loginAdvice").modal('show')
      }

      // if(window.location.hostname === 'localhost' && !this.logged){
      //   // Block for quick develop when creating orders
      //   this.checkout.address.billing_address = {
      //     street: 'Dr. Cardoso de Almeida',
      //     number: '110',
      //     zip_code: '18600-005',
      //     province: 'Centro',
      //     city: 'Botucatu',
      //     state: 'SP',
      //   }
      //
      //   this.checkout.address.shipping_address = {
      //     street: 'Dr. Cardoso de Almeida',
      //     number: '110',
      //     zip_code: '78850-000',
      //     province: 'Centro',
      //     city: 'Botucatu',
      //     state: 'SP',
      //     country: 'Brasil',
      //   }
      //
      //   let name = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
      //   this.checkout.profile = {
      //     name: name + ' ' + name,
      //     email: name + '@webtask.com.br',
      //     cpf: '',
      //     ie: '01010101',
      //     phone: '48996705445',
      //     password: '123123',
      //   }
      // }

      // preechimento automatico de cep
      var validacep = /^[0-9]{8}$/;
      let that = this
      that.checkout.address.shipping_address.country = 'Brasil'
      that.checkout.address.billing_address.country = 'Brasil'
      $("#billing_address_zip_code").blur(function() {
          that.checkout.address.billing_address.street = ''
          that.checkout.address.billing_address.province = ''
          that.checkout.address.billing_address.city = ''
          that.checkout.address.billing_address.state = ''
          that.checkout.address.billing_address.number = ''
          var cep = $('#billing_address_zip_code').val().replace(/\D/g, '');
          if (cep != "") {
              if(validacep.test(cep)) {
                  $.getJSON("https://viacep.com.br/ws/"+ cep +"/json/?callback=?", function(dados) {
                      if (!("erro" in dados)) {
                        that.checkout.address.billing_address.street = dados.logradouro
                        that.checkout.address.billing_address.province = dados.bairro
                        that.checkout.address.billing_address.city = dados.localidade
                        that.checkout.address.billing_address.state = dados.uf
                      }
                      that.$forceUpdate()
                  });
              }
          }
      });


      $("#shipping_address_zip_code").blur(function() {
          that.checkout.address.shipping_address.street = ''
          that.checkout.address.shipping_address.province = ''
          that.checkout.address.shipping_address.city = ''
          that.checkout.address.shipping_address.state = ''
          that.checkout.address.shipping_address.number = ''
          var cep = $("#shipping_address_zip_code").val().replace(/\D/g, '');
          if (cep != "") {
              if(validacep.test(cep)) {
                  $.getJSON("https://viacep.com.br/ws/"+ cep +"/json/?callback=?", function(dados) {
                      if (!("erro" in dados)) {
                        that.checkout.address.shipping_address.street = dados.logradouro
                        that.checkout.address.shipping_address.province = dados.bairro
                        that.checkout.address.shipping_address.city = dados.localidade
                        that.checkout.address.shipping_address.state = dados.uf
                      }
                      that.$forceUpdate()
                  });
              }
          }
      });

    },
    directives: { mask }
  }
</script>

<style scoped>
  .shipping_advice { margin-top: 10px; color: #761c19; }
</style>
